import React from "react";
import { Button } from "devextreme-react/button";
import { tabNames } from "../../../utils/strings";

const TabPanelActions = ({
  name,
  id,
  setOpenCreateModal,
  handleSave,
  setShowWarning,
}) => {
  return (
    <div style={{ width: "100%", display: "flex", alignItems: "flex-start" }}>
      {name === tabNames[0] && (
        <Button
          icon="add"
          type="success"
          style={{ marginRight: "8px" }}
          hint={`Add ${name}`}
          onClick={setOpenCreateModal}
        />
      )}
      <Button
        icon="save"
        type="normal"
        style={{ marginRight: "8px" }}
        hint={`Save ${name}`}
        onClick={handleSave}
      />
      <Button
        icon="trash"
        type="danger"
        hint={`Delete ${name}`}
        onClick={() => setShowWarning(true)}
      />
      <b style={{ marginLeft: "auto" }}>
        {name}-id: {id}
      </b>
    </div>
  );
};

export default TabPanelActions;
